import { render, staticRenderFns } from "./Admin-layout.vue?vue&type=template&id=ec252cb6&scoped=true&lang=pug&"
import script from "./Admin-layout.vue?vue&type=script&lang=js&"
export * from "./Admin-layout.vue?vue&type=script&lang=js&"
import style0 from "./Admin-layout.vue?vue&type=style&index=0&id=ec252cb6&lang=scss&scoped=true&"
import style1 from "./Admin-layout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec252cb6",
  null
  
)

export default component.exports